<template>
  <div class="toast">
    {{ list.msg }}
  </div>
</template>
<script>
export default {
  props: ["list"]
};
</script>
<style scoped>
.toast {
  letter-spacing: -0.46px;
  padding: 14px 30px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.76);
  color: #fff;
  text-align: center;
  line-height: normal;
  margin-bottom: 5px;
  white-space: nowrap;
  min-width: 260px;
  box-sizing: border-box;
}
</style>
